//Dialog.js
import React, { PureComponent } from "react";
import { zoomInDown, zoomOutUp, fadeIn, fadeOut } from "react-animations";
import { StyleSheet, css } from "aphrodite";
import Button from "@material-ui/core/Button";

const animations = StyleSheet.create({
	zoomInDown: {
		animationName: zoomInDown,
		animationDuration: "0.6s",
		animationFillMode: "forwards"
	},
	zoomOutUp: {
		animationName: zoomOutUp,
		animationDuration: "0.3s",
		animationFillMode: "forwards"
	},
	fadeIn: {
		animationName: fadeIn,
		animationDuration: "0.6s",
		animationFillMode: "forwards"
	},
	fadeOut: {
		animationName: fadeOut,
		animationDuration: "0.4s",
		animationFillMode: "forwards"
	}
});

const closeDialogTimeout = 400;
const openDialogTimeout = 500;

const styles = StyleSheet.create({
	fixedBox: {
		width: "100%",
		height: "100%",
		position: "fixed",
		top: "0px",
		zIndex: 100
	},
	absBox: {
		width: "100%",
		height: "100%",
		position: "absolute",
		top: "0px",
		zIndex: 9999
	},
	flexBox: {
		width: "100%",
		height: "100%",
		display: "flex",
		justifyContent: "center",
		alignItems: "center"
	},
	background: {
		width: "100%",
		height: "100%",
		position: "absolute",
		top: "0px",
		left: "0",
		backgroundColor: "rgba(0,0,0, 0.5)",
		display: "block",

		zIndex: "1000"
	},
	dialogBox: {
		width: "500px",
		height: "80%",
		display: "flex",
		flexDirection: "column",
		backgroundColor: "white",
		boxShadow:
			"0px 11px 15px -7px rgba(0, 0, 0, 0.2), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12)",
		overflow: "hidden"
	},
	dialogHeader: {
		height: "55px",
		display: "flex",
		flex: "0 0 auto",
		textTransform: "uppercase",
		justifyContent: "center",
		alignItems: "center",
		fontSize: "22px",
		color: "rgba(0,0,0,0.6)",
		borderBottom: "1px solid rgba(0,0,0, 0.05)"
	},
	dialogBody: {
		flex: "1 1 auto",
		overflowY: "auto",
		overflowX: "hidden"
	},
	dialogFooter: {
		display: "flex",
		justifyContent: "flex-end",
		alignItems: "center",
		flex: "0 0 auto",
		borderTop: "1px solid rgba(0,0,0, 0.05)",
		padding: "12px 12px"
	}
});

class Dialog extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			backgroundAnimation: animations.fadeIn,
			dialogAnimation: animations.zoomInDown,
			open: this.props.open
		};
		this.loaded = false;
	}

	onClick(e) {
		if (this.props.canClose === false) return;
		if (
			e.target &&
			e.target.getAttribute &&
			e.target.getAttribute("name") === "closeDialog"
		)
			this.closeDialog();
	}

	closeDialog() {
		if (this.loaded === false) return;

		this.setState({
			backgroundAnimation: animations.fadeOut,
			dialogAnimation: animations.zoomOutUp
		});
		setTimeout(() => {
			this.setState({ open: false });
			this.loaded = false;
			this.props.onClose();
		}, closeDialogTimeout);
	}

	openDialog() {
		this.setState({
			open: true,
			backgroundAnimation: animations.fadeIn,
			dialogAnimation: animations.zoomInDown
		});
		setTimeout(() => {
			this.loaded = true;
		}, openDialogTimeout);
	}

	renderDialogBase(children) {
		return (
			<div className={css(styles.fixedBox)}>
				<div
					className={css(styles.absBox)}
					onClick={this.onClick.bind(this)}
				>
					<div name="closeDialog" className={css(styles.flexBox)}>
						{this.renderDialogBox(children)}
					</div>
				</div>
				<div
					className={css(
						styles.background,
						this.state.backgroundAnimation
					)}
				/>
			</div>
		);
	}

	renderDialogBox(children) {
		return (
			<div className={css(styles.dialogBox, this.state.dialogAnimation)}>
				{this.renderDialogHeader()}
				<div className={css(styles.dialogBody)}>{children}</div>
				{this.renderDialogFooter()}
			</div>
		);
	}

	renderDialogHeader() {
		return (
			<div className={css(styles.dialogHeader)}>{this.props.title}</div>
		);
	}

	renderDialogFooter() {
		if (this.props.buttons == null) return null;
		return (
			<div className={css(styles.dialogFooter)}>
				{this.renderFooterButtons()}
			</div>
		);
	}

	renderFooterButtons() {
		let buttons = this.props.buttons.map((b, i) => {
			return (
				<Button
					key={"dialogButton" + i}
					variant="contained"
					color="secondary"
					onClick={() => b.onClick()}
				>
					{b.label}
				</Button>
			);
		});
		return buttons;
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.open === this.props.open) return;
		if (nextProps.open === false) this.closeDialog();
		else if (nextProps.open === true) this.openDialog();
	}

	componentDidMount = () => {
		if (this.props.open === true) this.openDialog();
	};

	render() {
		if (this.state.open === false) return null;
		return this.renderDialogBase(this.props.children);
	}
}

export default Dialog;
